<template>
  <div class="gid-password-reset">
    <div class="gid-bg-neutral reset-password-container">
      <p class="heading" v-if="!state">
        {{ $t('change-password.title') }}
      </p>
      <p class="heading" v-if="state === 'success'">
        {{ $t('change-password.success-state.title') }}
      </p>
      <p class="description" v-if="!state">
        {{
          $t('change-password.description') +
          ' ' +
          $route?.query?.email?.replace(' ', '+')
        }}
      </p>
      <ValidationObserver ref="observer" slim>
        <b-form class="form-wrapper" @submit.prevent v-if="!state">
          <validating-group
            class="validating-group w-100"
            :label="$t('password')"
            rules="required|password_regex|min:6"
            :validation-context="validation_context"
            validation-path="password"
            mode="passive"
            v-slot="{ clearErrors, errors, state }"
          >
            <b-input-group
              :class="`field-wrapper ${
                errors?.length ? 'is-invalid border-danger' : ''
              }`"
            >
              <b-form-input
                class="m-auto rounded-3 border-0 field password"
                v-model="password1"
                @input="password1 === '' && clearErrors(true)"
                :type="showPassword ? 'text' : 'password'"
                name="password"
                rules="required|password_regex|min:6"
                :state="state"
                :placeholder="$t('password')"
              />
              <button
                type="button"
                @click="showPassword = !showPassword"
                class="bg-none bg-white border-0 rounded-right pr-3"
              >
                <template v-if="showPassword">
                  <BIconEyeSlash />
                </template>
                <template v-else>
                  <BIconEye />
                </template>
              </button>
            </b-input-group>
          </validating-group>

          <validating-group
            class="validating-group w-100"
            :label="$t('repeat-password')"
            rules="required|confirmed:password"
            :validation-context="validation_context"
            validation-path="password_repeat"
            :mode="inputValidationMode"
            v-slot="{ clearErrors, errors, state }"
          >
            <b-input-group
              :class="`field-wrapper ${
                errors?.length ? 'is-invalid border-danger' : ''
              }`"
            >
              <b-form-input
                class="m-auto rounded-3 border-0 field password"
                v-model="password2"
                @input="password2 === '' && clearErrors(true)"
                :type="showConfirmPassword ? 'text' : 'password'"
                name="password_repeat"
                rules="required|confirmed:password"
                :state="state"
                :placeholder="$t('repeat-password')"
              />
              <button
                type="button"
                @click="showConfirmPassword = !showConfirmPassword"
                class="bg-none bg-white border-0 rounded-right pr-3"
              >
                <template v-if="showConfirmPassword">
                  <BIconEyeSlash />
                </template>
                <template v-else>
                  <BIconEye />
                </template>
              </button>
            </b-input-group>
          </validating-group>

          <div v-if="error" class="api-error text-danger w-100">
            {{ $t('change-password.fail') }}
          </div>

          <b-col class="gid-dark-theme actions-wrapper">
            <b-button
              class="reset-btn mb-2"
              variant="primary"
              type="submit"
              @click.prevent="changePassword"
            >
              <b-spinner v-if="loading" class="mr-2 gid-spinner--button" />
              {{ $t('change-password.buttons.request') }}
            </b-button>
            <router-link to="/login" class="back-to-login">
              {{ $t('request-password-reset.buttons.back-to-login') }}
            </router-link>
          </b-col>
        </b-form>
      </ValidationObserver>
      <b-col v-if="state === 'success'" variant="success" dismissible>
        <BIconCheckCircle class="api-response-icon text-primary" />
        <p class="description mb-0 mt-3">
          <router-link to="/login">
            {{ $t('request-password-reset.success-state.login-btn') }}
          </router-link>
        </p>
      </b-col>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { BIconCheckCircle, BIconEyeSlash, BIconEye } from 'bootstrap-vue';

const VALIDATION_CONTEXT = 'changePassword';

export default {
  components: {
    BIconCheckCircle,
    BIconEyeSlash,
    BIconEye,
  },
  props: {
    role: {
      type: String,
    },
  },
  data() {
    return {
      validation_context: VALIDATION_CONTEXT,
      error: null,
      state: null,
      password1: null,
      password2: null,
      showPassword: false,
      showConfirmPassword: false,
      loading: false,
    };
  },
  methods: {
    async changePassword() {
      this.loading = true;

      const formIsValid = await this.$refs.observer.validate();
      if (!formIsValid) {
        this.loading = false;
        return;
      }

      try {
        await axios.post(
          '/api/auth/set-password',
          {
            new_password: this.password1,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$route.query.token}`,
            },
          },
        );
        this.state = 'success';
        this.error = null;
      } catch (error) {
        this.state = null;
        this.error = true;
      }
      this.loading = false;
    },
  },
};
</script>
